import React, {useEffect, useMemo, useState, useCallback} from 'react'
import {useSelector} from "react-redux";

const RemoveBlockContent = (props) => {
    const {
        showBlock = true,
        hardDeleteBlock = true,
        actionRemove = (type, textReasons) => {
            console.log(`type: ${type}, reason: ${textReasons}`)
        }
    } = props

    const {
        phrases: {
            deletion_type,
            remove_from_public_view,
            item_will_remain_viewable_by_moderators_and_may_be_restored_at_later,
            selecting_this_option_will_permanently_and_irreversibly_delete_item,
            permanently_delete,
            reason
        }
    } = useSelector((state) => state.lots);

    const [textReasons, setTextReasons] = useState('')
    const [type, setType] = useState(null)

    const handleTypeChange = useCallback((selectedType) => {
        if (selectedType === 1) {
            setTextReasons('')
        }
        setType(selectedType);
    }, [])

    const handleReasonChange = useCallback((e) => {
        setTextReasons(e.target.value)
    }, [])

    // Вызываем actionRemove только когда type или textReasons изменяются
    useEffect(() => {
        if (type !== null) {
            actionRemove(type, textReasons)
        }
    }, [type, textReasons]) // Убрал actionRemove из зависимостей

    const removeFromPublicView = useMemo(() => {
        if (!showBlock) return null;

        return (
            <div className="form-check mb-4">
                <div className="d-flex align-items-start gap-3">
                    <input 
                        type="radio" 
                        className="form-check-input mt-1"
                        id="delete_type_one"
                        value={0}
                        name="hard_delete"
                        onChange={(e) => handleTypeChange(parseInt(e.target.value))}
                    />
                    <div className="flex-grow-1">
                        <label className="form-check-label fw-medium" htmlFor="delete_type_one">
                            {remove_from_public_view}
                        </label>
                        
                        <div className="mt-2">
                            <input 
                                className="form-control form-control-sm"
                                id='delete_reason_type_0'
                                type="text" 
                                name="reason"
                                value={textReasons}
                                onChange={handleReasonChange}
                                placeholder={`${reason || ''}...`}
                            />
                        </div>
                        
                        <div className="form-text text-muted mt-2">
                            {item_will_remain_viewable_by_moderators_and_may_be_restored_at_later}
                        </div>
                    </div>
                </div>
            </div>
        )
    }, [showBlock, textReasons, reason, remove_from_public_view, item_will_remain_viewable_by_moderators_and_may_be_restored_at_later, handleTypeChange, handleReasonChange])

    const hardRemoveForm = useMemo(() => {
        if (!hardDeleteBlock) return null;

        return (
            <div className="form-check mb-4">
                <div className="d-flex align-items-start gap-3">
                    <input 
                        type="radio"
                        className="form-check-input mt-1"
                        value={1}
                        name="hard_delete"
                        id="delete_type_two"
                        onChange={(e) => handleTypeChange(parseInt(e.target.value))}
                    />
                    <div className="flex-grow-1">
                        <label className="form-check-label fw-medium" htmlFor="delete_type_two">
                            {permanently_delete}
                        </label>
                        
                        <div className="form-text text-muted mt-2">
                            {selecting_this_option_will_permanently_and_irreversibly_delete_item}
                        </div>
                    </div>
                </div>
            </div>
        )
    }, [hardDeleteBlock, permanently_delete, selecting_this_option_will_permanently_and_irreversibly_delete_item, handleTypeChange])

    return (
        <div className="container-fluid p-0">
            <div className="row">
                <div className="col-12">
                    <h6 className="mb-3 fw-semibold">{deletion_type}</h6>
                    
                    {removeFromPublicView}
                    {hardRemoveForm}
                </div>
            </div>
        </div>
    );
}

export default RemoveBlockContent